import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=797dca92&scoped=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts"
import style1 from "./UserProfilePage.vue?vue&type=style&index=1&id=797dca92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dca92",
  null
  
)

export default component.exports